export const getToken = () => {
  let token = null;
  try {
    token = JSON.parse(localStorage.getItem("accessToken") ?? "");
  } catch (error) {
    token = null;
  }
  return token;
};
